<template>
    <div class="w-full">
        <custom-simple-select
            v-model="option"
            label="Tipo de destacado"
            :options="selectOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { referenceHighlightTypes } from "@/common/fields/reference-highlight-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "ReferenceHighlightTypeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => "highlight",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: Object.keys(referenceHighlightTypes)[0],
        $enabledOptions: referenceHighlightTypes
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
